import api from '../../api';
import { CreateTemplateRequest, TemplateComposicao } from '../../model/composicao/TemplateComposicao';

export class TemplateComposicaoViewModel {
    static async getAll(): Promise<TemplateComposicao[]> {
        const response = await api.get<TemplateComposicao[]>('/templates-composicao');
        return response.data;
    }

    static async getById(id: string): Promise<TemplateComposicao> {
        const response = await api.get<TemplateComposicao>(`/templates-composicao/${id}`);
        return response.data;
    }

    static async create(request: CreateTemplateRequest): Promise<TemplateComposicao> {
        const response = await api.post<TemplateComposicao>('/templates-composicao', request);
        return response.data;
    }

    static async createForAllTipos(request: CreateTemplateRequest): Promise<TemplateComposicao[]> {
        const response = await api.post<TemplateComposicao[]>('/templates-composicao/todos-tipos', request);
        return response.data;
    }

    static async desativar(id: string): Promise<TemplateComposicao> {
        const response = await api.patch<TemplateComposicao>(`/templates-composicao/${id}/desativar`);
        return response.data;
    }

    static async ativar(id: string): Promise<TemplateComposicao> {
        const response = await api.patch<TemplateComposicao>(`/templates-composicao/${id}/ativar`);
        return response.data;
    }

    static async delete(id: string): Promise<void> {
        await api.delete(`/templates-composicao/${id}`);
    }
}
